module.exports = __webpack_public_path__ + "img/arrow_forward.1a411b60.svg";